// The site is served from the same origin as the API, so requests are relative
// (no host, no CORS). An empty base makes `API_URL + "/status"` resolve to the
// current origin.
export const API_URL = "";
